/**
 * O DICIONARIO DAS PECAS DE INTERFACE, em ingles.
 *
 * POR QUE ELE PRECISOU EXISTIR, medido em 08/09/2026 por dois agentes ao mesmo tempo:
 * `(obrigatório)` estava CRAVADO em portugues em tres componentes deste pacote
 * (`CampoTexto`, `Input` e `CampoBusca`), sem passar pelo dicionario.
 *
 * O DEFEITO ERA INVISIVEL, e isso e o que o torna grave: a frase vai dentro de
 * `cx-so-leitor`, entao ela NAO APARECE na tela. Quem a recebe e quem usa leitor de tela, e
 * com a interface inteira em ingles a pessoa ouvia "Email, star, (obrigatório)". Nenhuma
 * varredura visual pegaria isso, e nenhum teste de tela que le texto renderizado tambem.
 *
 * O DICIONARIO E DO PACOTE, e nao de cada app, pela mesma razao do chassi de entrada: a
 * frase e identica em todo produto, e escrita em cada `en.ts` de app seria a mesma traducao
 * em N lugares. O VOE ja tinha `(obrigatório)` traduzido no dicionario dele, e a traducao
 * existia sem alcançar o componente: prova de que o problema nunca foi falta de traducao, e
 * sim o componente nao consultar dicionario nenhum.
 */
import type { Dicionario } from '@complexity/i18n';

export const EN_UI: Dicionario = {
  // O SUFIXO DE CAMPO OBRIGATORIO, dito so para quem ouve. Na tela quem marca e o asterisco.
  '(obrigatório)': '(required)',

  // AS FRASES DO CHASSI E DAS PEÇAS que saíam em português com a tela em inglês, medidas no
  // inventário de botões de 11/09/2026 e traduzidas por decisão do fundador em enquete. O nome
  // acessível da marca no Rail ficou de fora, por ser peça congelada do VOE.
  'Abrir menu': 'Open menu',
  'Fechar menu': 'Close menu',
  'Recolher menu': 'Collapse menu',
  'Expandir menu': 'Expand menu',
  // O valor ausente no painel da conta (Rail, `sairNaConta`), desde 12/09/2026.
  'Não cadastrado': 'Not registered',
  'Idioma': 'Language',
  'Mudar para tema escuro': 'Switch to dark theme',
  'Mudar para tema claro': 'Switch to light theme',
  'Ditar': 'Dictate',
  'Parar de ditar': 'Stop dictating',
  'Anexar imagem': 'Attach image',
  'Preparando…': 'Preparing…',
};
